/**
 * Enum representing different food and dietary tags
 * Aligned with backend TagEnum codes
 */
export enum Tags {
    // Spice levels
    SPICY = 'SPY',        // Spicy food items
    
    // Dietary preferences
    VEGAN = 'VGN',        // Vegan food items
    VEGETARIAN = 'VGT',   // Vegetarian food items
    GLUTEN_FREE = 'GFR',  // Gluten-free options
    DAIRY_FREE = 'DFR',   // Dairy-free options
    HALAL = 'HLL',        // Halal certified food
    KOSHER = 'KSR',       // Kosher certified food
    KETO = 'KTO',         // Keto-friendly options
    PALEO = 'PLO',        // Paleo diet options
    SEAFOOD = 'SFL',      // Seafood dishes

    // Special features
    NEW = 'NEW',          // New menu items
    CHEFS_CHOICE = 'CHF', // Chef's special selections
    RECOMMENDED = 'REC',  // Recommended dishes
    HOUSE_SPECIALTY = 'HSP', // House specialty dishes
    LIMITED_EDITION = 'LMT', // Limited time offerings
    SHARING = 'SHR',      // Dishes great for sharing
    BREAKFAST = 'BRK',    // Breakfast items

    // Quality indicators
    ORGANIC = 'ORG',      // Organic ingredients/dishes
    LOCAL = 'LCL',        // Locally sourced ingredients
    HOMEMADE = 'HMD',     // Homemade dishes
    NO_ADDITIVES = 'NAD'  // No artificial additives
}
